import { Integration, IntegrationTypes } from 'models/integrations'
import api from '../index'

export interface IIntegrationAPI {
  data: {
    attributes: Integration
    id: string
    type: string
  }
}

export const getIntegration = (type: keyof typeof IntegrationTypes) => {
  return api
    .get<IIntegrationAPI>(`integrations/${type}`)
    .then((res) => res?.data)
    .then(({ data }) => data?.attributes)
}

export default getIntegration
